import React from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES } from '../data/shayari';
import { useApp } from '../context/AppContext';
import Logo from './Logo';

const Footer = () => {
  const { language } = useApp();
  const isRtl = language === 'ur';
  const t = {
    categories:  language === 'ur' ? 'زمرے'        : language === 'hi' ? 'श्रेणियाँ'    : language === 'es' ? 'Categorías'     : language === 'fr' ? 'Catégories'    : 'Categories',
    more:        language === 'ur' ? 'مزید'         : language === 'hi' ? 'और अधिक'     : language === 'es' ? 'Más'            : language === 'fr' ? 'Plus'          : 'More',
    quickLinks:  language === 'ur' ? 'فوری لنکس'   : language === 'hi' ? 'त्वरित लिंक' : language === 'es' ? 'Enlaces Rápidos': language === 'fr' ? 'Liens Rapides' : 'Quick Links',
    legal:       language === 'ur' ? 'قانونی'       : language === 'hi' ? 'कानूनी'       : language === 'es' ? 'Legal'          : language === 'fr' ? 'Légal'         : 'Legal',
    home:        language === 'ur' ? '🏠 مرکزی'    : language === 'hi' ? '🏠 मुख्य पृष्ठ' : language === 'es' ? '🏠 Inicio'    : language === 'fr' ? '🏠 Accueil'    : '🏠 Home',
    poets:       language === 'ur' ? '✍️ شاعر'     : language === 'hi' ? '✍️ शायर'      : language === 'es' ? '✍️ Poetas'     : language === 'fr' ? '✍️ Poètes'     : '✍️ Poets',
    favorites:   language === 'ur' ? '❤️ پسندیدہ' : language === 'hi' ? '❤️ पसंदीदा'  : language === 'es' ? '❤️ Favoritos'  : language === 'fr' ? '❤️ Favoris'    : '❤️ Favorites',
    about:       language === 'ur' ? 'ℹ️ ہمارے بارے میں' : language === 'hi' ? 'ℹ️ हमारे बारे में' : language === 'es' ? 'ℹ️ Acerca de' : language === 'fr' ? 'ℹ️ À propos'  : 'ℹ️ About Us',
    contact:     language === 'ur' ? '📩 رابطہ کریں' : language === 'hi' ? '📩 संपर्क करें' : language === 'es' ? '📩 Contacto'  : language === 'fr' ? '📩 Contact'    : '📩 Contact Us',
    privacy:     language === 'ur' ? '🔒 رازداری پالیسی' : language === 'hi' ? '🔒 गोपनीयता नीति' : language === 'es' ? '🔒 Privacidad' : language === 'fr' ? '🔒 Confidentialité' : '🔒 Privacy Policy',
    terms:       language === 'ur' ? '📋 شرائط و ضوابط' : language === 'hi' ? '📋 नियम एवं शर्तें' : language === 'es' ? '📋 Términos'  : language === 'fr' ? '📋 Conditions' : '📋 Terms & Conditions',
    copyrightPolicy: language === 'ur' ? '©️ کاپی رائٹ' : language === 'hi' ? '©️ कॉपीराइट नीति' : language === 'es' ? '©️ Copyright' : language === 'fr' ? '©️ Droits d\'auteur' : '©️ Copyright Policy',
    copyright:   language === 'ur' ? '© 2025 شایری۔ شاعری کے عاشقوں کے لیے ❤️ سے بنایا' : language === 'hi' ? '© 2025 शायरी। कविता प्रेमियों के लिए ❤️ से बनाया' : language === 'es' ? '© 2025 ShayariStudio. Todos los derechos reservados.' : language === 'fr' ? '© 2025 ShayariStudio. Tous droits réservés.' : '© 2025 शायरी Shayari. Made with ❤️ for lovers of poetry.',
    privacyShort: language === 'ur' ? 'رازداری پالیسی' : language === 'hi' ? 'गोपनीयता नीति' : language === 'es' ? 'Privacidad' : language === 'fr' ? 'Confidentialité' : 'Privacy Policy',
    termsShort:  language === 'ur' ? 'شرائط' : language === 'hi' ? 'नियम' : language === 'es' ? 'Términos' : language === 'fr' ? 'Conditions' : 'Terms',
    contactShort: language === 'ur' ? 'رابطہ' : language === 'hi' ? 'संपर्क' : language === 'es' ? 'Contacto' : language === 'fr' ? 'Contact' : 'Contact',
  };

  return (
  <footer className="footer" dir={isRtl ? 'rtl' : 'ltr'}>
    <div className="footer__glow" />
    <div className="footer__inner">
      <div className="footer__grid">
        {/* Brand */}
        <div className="footer__brand">
          <div className="footer__logo" style={{marginBottom:'1rem'}}>
            <Logo size="md" linked={true} />
          </div>
          <p className="footer__tagline">
            {language==='ur'?'شاعری جہاں روح سے ملتی ہے':language==='hi'?'जहाँ शब्द दिल से बोलते हैं':language==='es'?'Donde la poesía toca el alma.':language==='fr'?'Là où la poésie rencontre l\'âme.':'Where poetry meets the soul.'}
          </p>
          <div className="footer__social">
            <a href="https://www.youtube.com/@ShayariStudio-f8k" target="_blank" rel="noopener noreferrer" className="footer__social-btn" title="YouTube">▶️</a>
          </div>
        </div>

        {/* Categories */}
        <div className="footer__col">
          <h4 className="footer__col-title">{t.categories}</h4>
          <ul className="footer__links">
            {CATEGORIES.slice(0, 6).map(cat => (
              <li key={cat.id}>
                <Link to={`/category/${cat.id}`} className="footer__link">
                  {cat.icon} {language === 'ur' ? cat.urdu : language === 'hi' ? cat.hindi : cat.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h4 className="footer__col-title">{t.more}</h4>
          <ul className="footer__links">
            {CATEGORIES.slice(6).map(cat => (
              <li key={cat.id}>
                <Link to={`/category/${cat.id}`} className="footer__link">
                  {cat.icon} {language === 'ur' ? cat.urdu : language === 'hi' ? cat.hindi : cat.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick links */}
        <div className="footer__col">
          <h4 className="footer__col-title">{t.quickLinks}</h4>
          <ul className="footer__links">
            <li><Link to="/" className="footer__link">{t.home}</Link></li>
            <li><Link to="/poets" className="footer__link">{t.poets}</Link></li>
            <li><Link to="/favorites" className="footer__link">{t.favorites}</Link></li>
            <li><Link to="/about" className="footer__link">{t.about}</Link></li>
            <li><Link to="/contact" className="footer__link">{t.contact}</Link></li>
          </ul>
          <h4 className="footer__col-title" style={{marginTop:'1.5rem'}}>{t.legal}</h4>
          <ul className="footer__links">
            <li><Link to="/privacy-policy" className="footer__link">{t.privacy}</Link></li>
            <li><Link to="/terms" className="footer__link">{t.terms}</Link></li>
            <li><Link to="/copyright" className="footer__link">{t.copyrightPolicy}</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <p>{t.copyright}</p>
        <div style={{display:'flex',gap:'1rem',flexWrap:'wrap',alignItems:'center'}}>
          <Link to="/privacy-policy" className="footer__link" style={{fontSize:'.8rem'}}>{t.privacyShort}</Link>
          <span style={{color:'var(--text-muted)'}}>·</span>
          <Link to="/terms" className="footer__link" style={{fontSize:'.8rem'}}>{t.termsShort}</Link>
          <span style={{color:'var(--text-muted)'}}>·</span>
          <Link to="/contact" className="footer__link" style={{fontSize:'.8rem'}}>{t.contactShort}</Link>
        </div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
